/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import { buildingWireless2Offblack } from "../assets/building-wireless-2-offblack";
import {
  type StaticIllustrativeBaseIconProps,
  StaticIllustrativeIcon,
} from "../static-illustrative-icon";

export const IllustrativeIconBuildingWireless2Offblack = (props: StaticIllustrativeBaseIconProps) => (
  <StaticIllustrativeIcon {...props} svg={buildingWireless2Offblack.svg} />
);

IllustrativeIconBuildingWireless2Offblack.displayName = "IllustrativeIconBuildingWireless2Offblack";
